<template>
  <div v-if="!isSubscribe">
    <van-popup class="focus-popup" v-model="showFocusPopup" :close-on-click-overlay="false" :safe-area-inset-bottom="true" position="bottom">
      <div class="focus-popup__hd">开启课程解锁提醒</div>
      <div class="focus-popup__bd">
        <img class="qr" src="https://mmcb-pub.oss-cn-hangzhou.aliyuncs.com/mmcb-qrcode-v3.jpg" alt="">
        <p>长按访问明明城堡公众号并关注</p>
        <p>将以微信服务消息形式通知您</p>
      </div>
      <!-- <div class="focus-popup__ft">
        <van-button class="focus-popup__ft-btn" block round type="warning" @click="showFocusPopup=false">我知道了</van-button>
      </div> -->
      <div class="close_btn" @click="showFocusPopup=false">
        <img :src="require('@/assets/icons/close.png')" />
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'Subscribe',
  props: {
    isSubscribe: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showFocusPopup: true
    }
  }
}
</script>

<style lang="scss" scoped>
.focus-popup {
  text-align: center;
  .focus-popup__hd {
    font-size: 16px;
    color: #282828;
    font-weight: bold;
    padding: 16px 0;
  }
  .focus-popup__bd {
    color: #666;
    font-size: 14px;
    line-height: 1.5em;
    margin-bottom: 10px;
    .qr {
      height: 168px;
      display: block;
      margin: 0 auto;
      padding-bottom: 16px;
    }
  }
  .focus-popup__ft {
    padding: 16px 52px;
    .focus-popup__ft-btn {
      &.van-button--warning {
        background-color: #FF771D;
        border-color: #FF771D;
      }
    }
  }
  .close_btn {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 44px;
    height: 44px;
    img {
      width: 22px;
      height: 22px;
      margin: auto;
    }
  }
}
</style>
